import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const DELETE_WORKSPACE: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation deleteWorkspace($input: DeleteWorkspaceInput!) {
    deleteWorkspace(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
